import { type ApolloClient, type NormalizedCacheObject } from "@apollo/client";
import { type WritableDraft } from "immer";
import { createContext, useContext } from "react";

export type WallConfigContextState = {
  clientDataAccess?: ApolloClient<NormalizedCacheObject>;
  clientAnalytics?: ApolloClient<NormalizedCacheObject>;
  enabled: boolean;
  organization?: string;
  location?: string;
  profile?: string;
  update: (
    callback: (draft: WritableDraft<WallConfigContextState>) => void,
  ) => void;
};

export const defaultWallConfig: WallConfigContextState = {
  enabled: false,
  organization: undefined,
  location: undefined,
  profile: undefined,
  update: () => undefined,
};

export const WallConfigContext =
  createContext<WallConfigContextState>(defaultWallConfig);
export const useWallConfig = () => useContext(WallConfigContext);
